import React from 'react'

export const SearchResultList = () => {
  return (
    <div>SearchResult</div>
  )
}

export default SearchResultList;